export const EMAIL = 'email';
export const PERMISSION = 'permission';
export const STORE_ID = 'store_id';
